import { motion } from 'motion/react';

export default function GamePreviewShell({
  title,
  onClose,
  children,
  wide,
  containBody = false,
  fullscreen = false,
  /** Просвет сверху под панель лобби (клики проходят в топбар); затемнение только снизу */
  leaveTopBarGap = false,
  /** Поверх остальных модалок (например магазин токенов при открытом альбоме) */
  overlayZClass = 'z-[60]'
}) {
  const card = (
    <motion.div
      className={`flex w-full flex-col overflow-hidden bg-game-canvas shadow-2xl ${
        fullscreen
          ? 'h-dvh max-h-dvh min-h-0 w-full max-w-none rounded-none border-0 sm:rounded-none'
          : `rounded-2xl border border-white/10 ${
              wide ? 'max-w-4xl' : 'max-w-lg'
            } ${
              containBody
                ? leaveTopBarGap
                  ? 'h-[min(calc(100dvh-5.5rem),680px)] max-h-[min(calc(100dvh-5.5rem),92vh)] min-h-0'
                  : 'h-[min(85dvh,720px)] max-h-[92vh] min-h-0'
                : 'max-h-[92vh]'
            }`
      }`}
      initial={{ opacity: 0, y: 18, scale: 0.98 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: 14, scale: 0.98 }}
      transition={{ type: 'spring', damping: 26, stiffness: 340 }}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="flex shrink-0 items-center justify-between border-b border-white/10 bg-game-popup/50 px-4 py-3">
        <h2 id="game-ui-preview-title" className="text-sm font-semibold tracking-tight text-game-text">
          {title}
        </h2>
        <button
          type="button"
          onClick={onClose}
          className="rounded-md px-2 py-1 text-xs text-game-muted transition hover:bg-white/10 hover:text-game-text"
        >
          Close
        </button>
      </div>
      <div
        className={
          containBody
            ? 'flex min-h-0 flex-1 flex-col overflow-hidden'
            : 'vr-scroll-y min-h-0 flex-1 overflow-y-auto'
        }
      >
        {children}
      </div>
    </motion.div>
  );

  if (leaveTopBarGap) {
    return (
      <motion.div
        role="dialog"
        aria-modal="true"
        aria-labelledby="game-ui-preview-title"
        className={`fixed inset-0 flex flex-col ${overlayZClass}`}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <div className="pointer-events-none h-16 shrink-0 sm:h-[4.25rem]" aria-hidden />
        <motion.div
          className="flex min-h-0 flex-1 items-center justify-center bg-black/80 px-3 py-3 sm:px-6 sm:py-5"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          {card}
        </motion.div>
      </motion.div>
    );
  }

  return (
    <motion.div
      role="dialog"
      aria-modal="true"
      aria-labelledby="game-ui-preview-title"
      className={`fixed inset-0 flex bg-black/80 ${overlayZClass} ${
        fullscreen ? 'items-stretch justify-stretch p-0' : 'items-center justify-center p-3 sm:p-6'
      }`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={onClose}
    >
      {card}
    </motion.div>
  );
}
